/* ============
 * Team Transformer
 * ============
 *
 * The transformer for the team
 */

import Transformer from './transformer'
import {startCase} from 'lodash'

export default class teamTransformer extends Transformer {
  /**
   * Method used to transform a fetched team
   *
   * @param team The fetched team
   *
   * @returns {Object} The transformed team
   */
  static fetch (team) {
    let membersRows = []
    if (team['property_Team_Member']) {
      membersRows = this.nSmaller(team['property_Team_Member'].split('||'), 3)
    }

    let titleArray = team['name'].split(' ')
    let titleYear = titleArray.shift()
    if (titleYear === 'The') {
      titleYear = 'The ' + titleArray.shift()
    }
    const titleSport = titleArray.join(' ')

    const sport = team['property_athletics'] ? team['property_athletics'][0] : ''
    const years = team['property_school_year'] ? team['property_school_year'][0].replace('_', '-') : ''
    const gender = team['property_gender'] ? team['property_gender'][0] : ''

    return {
      id: team['id'],
      teamName: `${sport} ${years} ${gender}`,
      sortName: `${years} ${sport} ${gender}`.toLowerCase(),
      sport: sport,
      years: years,
      gender: gender,
      captains: team['property_Captain'] ? team['property_Captain'].split('||') : [],
      coaches: team['property_Coach'] ? team['property_Coach'].split('||') : [],
      championships: team['property_Championships'] ? startCase(team['property_Championships'][0]).split(' ') : '',
      date_inducted: team['property_Date_Inducted'],
      // from 1999-2000 to [1990]
      decades: [years.split('-')[0].slice(0, -1) + '0'],
      description: team['description'],
      managers: team['property_Manager'] ? team['property_Manager'].split('||') : [],
      members_rows: membersRows,
      not_pictured: team['property_Not_Pictured'] ? team['property_Not_Pictured'].split('||') : [],
      order: team['property_Order'],
      thumbnail_url: team['thumbnails']['thul'],
      photograph_url: team['original'] ? team['original'] : team['thumbnails']['webimage'],
      title: team['name'],
      title_year: titleYear,
      title_sport: titleSport,
      hallOfFame: team['property_Date_Inducted'] !== undefined,
      hofYear: team['property_Team_Year'] ? team['property_Team_Year'][0] : '',
    }
  }
}
